import AsyncStorage from "@react-native-async-storage/async-storage";

export const asyncStorageSetItem = (key: string, data: unknown) =>
    AsyncStorage.setItem(key, JSON.stringify(data));

export const asyncStorageGetItem = (key: string) =>
    AsyncStorage.getItem(key);

export const asyncStorageRemoveItem = (key: string) => 
    AsyncStorage.removeItem(key);